import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import ProSearch from './ProSearch'
import { Button } from '../../../cwp-components/forms/Buttons'
import useIntelligenceSearch from 'common/providers/useIntelligenceSearch'
import { InteractiveTextArea } from './InteractiveTextArea'

export const LawyerSearch = () => {
  const navigate = useNavigate()
  const { createSearch, searchResultLoading } = useIntelligenceSearch()
  const [isProSearch, toggleProSearch] = useState(false)
  const [description, setDescription] = useState('')
  const handleSearch = () => {
    if (!description.trim()) {
      alert('Please enter a description')
      return
    }
    createSearch(
      { query: description },
      {
        onSuccess: () => navigate('/find-a-lawyer'),
        onError: (error) => console.log('error', error),
      },
    )
  }

  return (
    <div className='pb-12 inline-flex flex-col justify-start items-center gap-6'>
      <div className='inline-flex gap-4'>
        <div className='flex cursor-pointer flex-col items-start w-fit'>
          <div onClick={() => toggleProSearch(false)}>Search</div>
          {!isProSearch && <div className='w-full h-1 bg-cyan-700' />}
        </div>
        <div className='flex cursor-pointer flex-col items-start w-fit'>
          <div onClick={() => toggleProSearch(true)}>Pro search</div>
          {isProSearch && <div className='w-full h-1 bg-cyan-700' />}
        </div>
      </div>
      {isProSearch ? (
        <ProSearch />
      ) : (
        <div className='flex flex-col items-stretch gap-6 w-[95vw] sm:w-[50vw]'>
          <InteractiveTextArea
            placeholder='Tell us what has brought you here today...'
            value={description}
            setValue={setDescription}
            multiline
            rows={7}
          />

          <div className='flex justify-end pt-6'>
            <Button
              onClick={handleSearch}
              className={
                description.trim()
                  ? 'text-white bg-[#020251]'
                  : 'bg-[#F4F4F4] text-gray-500 cursor-not-allowed'
              }
            >
              {searchResultLoading ? 'Searching...' : 'Search'}
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
